import { orange } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "dark",

    background: {
      default: "#0B1020",
      paper: "#12182B",
    },

    primary: {
      main: "#5B8CFF",
      light: "#7FA2FF",
      dark: "#3B5EDB",
    },

    secondary: {
      main: "#E056FD",
      light: "#F08CFF",
      dark: "#B23BCF",
    },

    info: {
      main: "#2DE2E6",
    },

    success: {
      main: "#3CF0C5",
    },

    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255,255,255,0.7)",
      disabled: "rgba(255,255,255,0.4)",
    },

    divider: "rgba(255,255,255,0.06)",
  },

  shape: {
    borderRadius: 16,
  },

  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",

    h4: {
      fontWeight: 800,
      letterSpacing: 0.4,
    },

    h5: {
      fontWeight: 700,
    },

    h6: {
      fontWeight: 600,
    },

    body1: {
      fontSize: "0.95rem",
    },

    body2: {
      fontSize: "0.85rem",
      color: "rgba(255,255,255,0.7)",
    },

    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },

  custom: {
    colors: {
      border: "rgba(255,255,255,0.06)",
      glass: "rgba(11,16,32,0.75)",
      white: "rgba(255, 255, 255, 1)",
      grey: "rgba(216, 216, 216, 1)",
    },

    gradients: {
      green: "linear-gradient(135deg, #309903ff, #39d243ff)",
      bluePurple: "linear-gradient(135deg, #5B8CFF, #B26CFF)",
      aws: "linear-gradient(135deg, #f26406ff, #f29252ff)",
      kubernetes: "linear-gradient(135deg, #5b86e5, #36d1dc)",
      terraform: "linear-gradient(135deg, #B26CFF, #E056FD)",
      card: "linear-gradient(135deg, #1A2140, #141A33)",
      purplePink: "linear-gradient(135deg, #B26CFF 0%, #E056FD 100%)",
    },

    shadow: {
      soft: "0 12px 24px rgba(0,0,0,0.4)",
      strong: "0 20px 40px rgba(0,0,0,0.6)",
    },
  },

  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          background: "linear-gradient(135deg, #1A2140, #141A33)",
          border: "1px solid rgba(255,255,255,0.06)",
          backdropFilter: "blur(12px)",
          transition: "all 0.25s ease",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingLeft: 20,
          paddingRight: 20,
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(11,16,32,0.8)",
          backdropFilter: "blur(14px)",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
        },
      },
    },
  },
});
